import React, { useEffect, useMemo, useState } from 'react';
import { useReactTable, getCoreRowModel, flexRender, getFilteredRowModel, getExpandedRowModel, getPaginationRowModel } from "@tanstack/react-table";
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AddIcon from '@material-ui/icons/Add';
import {  Menu, MenuItem } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CloseIcon from '@material-ui/icons/Close';
import DropdownOptions from '../FeildExtensionDropdown';
import EditIcon from '@material-ui/icons/Edit';
import './style.css'

const attributes_options = [
  {
    id: "constraint",
    title: "Dropdown"
  },
  {
    id: "default",
    title: "Default"
  },
  {
    id: "optional",
    title: "Optional"
  },

  {
    id: "masked",
    title: "Masked"
  },
  {
    id: "readonly",
    title: "Read only"
  }
]



const FieldExtensionTable = ({onLoadData, setExtendedFieldsData}) => {
  const [expanded, setExpanded] = useState({});
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuPosition, setMenuPosition] = useState(null);
  const [dropdownPosition, setDropdownPosition] = useState(null);
  const [dropdownSchema, setDropdownSchema] = useState(null);

  const [dropdownAnchorEl, setDropdownAnchorEl] = React.useState(null);

  const [tableData, setTableData] = useState(addSubRows(onLoadData)  || []);

  function filterOutSubRows(schema) {
    const updateSchema = (schema) => {
      return schema.map(item => {

        let updatedItem = {
          ...item
        }
        
        delete updatedItem.subRows;

        if(updatedItem?.children && updatedItem?.children?.length > 0){
          updatedItem.children = updateSchema(updatedItem.children)
        }

        return updatedItem; 
      })
    }

    const updatedData = updateSchema(schema)
    return updatedData;
  }

  useEffect(() => {
    setTableData(addSubRows(onLoadData));
  }, [onLoadData, ])

  useEffect(() => {

  }, [dropdownAnchorEl])
  

  


  function addSubRows(schema) {
    const updateSchema = (schema) => {
      return schema?.map(item => {
        if (item?.children && item?.children?.length > 0) {
          item.children = updateSchema(item.children)
        }

        return {
          ...item,
          subRows: item.children && item.children.length > 0 ? item.children : undefined
        };
      })
    }

    const updatedData = updateSchema(schema) 
    return updatedData;
  }

  const filterMenuOptions = (options, type) => {
    const structAttributes = ["optional"]

    let filteredOptions = type == "struct" ? options?.filter(item => structAttributes?.includes(item?.id)) : options;

    return filteredOptions;
  }

  const handleMenuOpen = (event, rowId) => {
    setAnchorEl(event.currentTarget); 
    setSelectedRowId(rowId);

    setMenuPosition({
      top: event.clientY, // Get cursor Y position
      left: event.clientX, // Get cursor X position
    });
  };

  const updateSchemaWithAttribute = ({ rowId, attribute, value, action }) => {
    // console.log("updateSchemaWithAttribute---------------", {rowId, attribute, value, action})
    try {
      const field_id = rowId || selectedRowId;
      // console.log("field_id: ", field_id)

      if (field_id == null) {
        return
      }

      if (attribute == undefined) {
        return
      }

      const updateSchema = (schema) => {
        return schema?.map(item => {
          if (item?.children && item?.children?.length > 0) {
            item.children = updateSchema(item.children)
          }

          let updatedItem = {
            ...item
          };
          if (item?.id == field_id) {
            if (attribute == "default") {
              if (action == "add") {
                updatedItem.default = value || "";
              } else {
                delete updatedItem.default;
              }
            } else if (attribute == "optional") {
              if (action == "add") {
                updatedItem.optional = true
              } else {
                delete updatedItem.optional;
              }
            } else if (attribute == "masked") {
              if (action == "add") {
                updatedItem.masked = true
              } else {
                delete updatedItem.masked;
              }
            } else if (attribute == "readonly") {
              if (action == "add") {
                updatedItem.readonly = true
              } else {
                delete updatedItem.readonly;
              }
            }else if (attribute == "constraint") {
              if (action == "add" || action == "edit") {
                // console.log(`--constraint ${action}--`)
                updatedItem.constraint = value || [];
              } else {
                delete updatedItem.constraint;
              }
            }

          }



          return updatedItem;
        })
      }

      const updatedSchema = updateSchema(tableData);
      setTableData(addSubRows(updatedSchema));
      setExtendedFieldsData(filterOutSubRows(updatedSchema));
      setSelectedRowId(null);
      setDropdownSchema([{key: "", label: ""}]);

    } catch (error) {
      console.error("Updating schema with attribute failed. ", error);
    }
  }


  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuPosition(null);

    // setSelectedRowId(null);
  };

  const findConstraintValueFromTableData = (id) => {
    // console.log('findConstraintValueFromTableData------------------', id)
    const findField = (fields) => {
      return fields?.find(field => {
        if(field?.id == id) return field;

        if(field.children){
          findField(field.children)
        }
      })
    }

     
    const field = findField(tableData);;
    const value = field?.constraint ? field?.constraint : field?.defaultConstraint ? field?.defaultConstraint : [{label: "", value: ""}]; 
    return value;

  }

  const handleOptionClick = (option, event, rowId) => {
    setSelectedRowId(rowId);
    if(option === "constraint"){
      // console.log("--dropdown--")
      setDropdownAnchorEl(event.currentTarget);
      setDropdownPosition({
        top: event.clientY, // Get cursor Y position
        left: event.clientX, // Get cursor X position
      });
      setDropdownSchema(findConstraintValueFromTableData(rowId));
      handleMenuClose();
      return
    }

    updateSchemaWithAttribute({ attribute: option, action: 'add' })
    handleMenuClose();
  };


  const removeAttributePill = (attribute, rowId) => {
    updateSchemaWithAttribute({ rowId, action: "remove", attribute })
  }


  const AttributePill = ({ attribute, rowId }) => {
    
    const handleDefaultOnBlur = (event) => {
      const inputValue = event.target.value;
      updateSchemaWithAttribute({ rowId, attribute: attribute?.name, value: inputValue, action: "add"})
    };

    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.target.blur(); 
      }
    };
    
    const showInputField = ["default"]

    const handleEditDropdown = (event,  value, rowId) => {
      // console.log("handleEditDropdown----------", {value, rowId})
      setSelectedRowId(rowId);
      setDropdownAnchorEl(event.currentTarget);
      setDropdownPosition({
        top: event.clientY, // Get cursor Y position
        left: event.clientX, // Get cursor X position
      });
      setDropdownSchema(value);
    }

    return (
      <div className={`attribute_pill attribute_pill_${attribute?.name}`} name={attribute.name}>
        <span>{attribute?.title} {showInputField?.includes(attribute?.name) && ": "}</span>
        {showInputField?.includes(attribute?.name)  && <input type="text" defaultValue={attribute.value ? attribute.value : ""} onBlur={handleDefaultOnBlur} onKeyDown={handleKeyDown} />}
        {attribute?.name == "constraint" && <EditIcon className={'edit_dropdown'} onClick={(event) => handleEditDropdown(event, attribute?.value, rowId)}   /> }
        <CloseIcon className={'attribute_pill_close'} onClick={() => removeAttributePill(attribute?.name, rowId)} />

      </div>


    )
  }


  const ListAttributes = ({ attributes, rowId }) => {
    // console.log("ListAttributes-------------", { attributes, rowId })
    if (attributes?.length == 0) {
      return <span></span>
    }

    return (
      <div className={'attributes_list'} >
        {
          attributes?.map(item => (
            <AttributePill attribute={item} rowId={rowId} />
          ))
        }
        

      </div>
    )
  }





  const formatFieldType = (type) => {
    return (type == "BOOL" ? "boolean" : type)?.toLowerCase() || "";
  }

  const findExtendedAttributes = (item) => {
    let attributes = []
    if (item == undefined) {
      return attributes;
    }


    if (item?.default != undefined) {
      attributes.push({ name: 'default', title: 'Default', value: item?.default || "" })
    }

    if (item?.masked) {
      attributes.push({ name: 'masked', title: "Masked", value: item.masked })
    }

    if (item?.readonly) {
      attributes.push({ name: 'readonly', title: "Read only", value: item.readonly })
    }

    if (item?.optional) {
      attributes.push({ name: 'optional', title: "Optional", value: item.optional })
    }

    if (item?.constraint != undefined) {
      attributes.push({ name: 'constraint', title: "Dropdown", value: item?.constraint })
    }

    return attributes;
  }


  const getOptionItemColor = (item, attribute) => {
    if(item.hasOwnProperty(attribute) && item[attribute] !== undefined ){
      // console.log(`attribute ${attribute}: `, item[attribute])
      return "green"
    }else{
      return "wheat"
    }
  }


  const columns = useMemo(() => {
    return [
      {
        accessorKey: "name",
        header: "Field",
        cell: ({ row, getValue }) => (
          <div style={{ display: 'flex', alignItems: 'center', paddingLeft: `${row.depth * 2}rem` }}>
            {row.getCanExpand() ? (
              <>
                {row.getIsExpanded()
                  ? <ArrowDropDownIcon onClick={row.getToggleExpandedHandler()} style={{ cursor: "pointer" }} />
                  : <ArrowRightIcon onClick={row.getToggleExpandedHandler()} style={{ cursor: "pointer" }} />
                }
              </>
            ) : (
              ""
            )}
            {getValue()}
          </div>
        ),
      },
      {
        accessorKey: "type",
        header: "Type",
        cell: ({ row, getValue }) => (
          formatFieldType(row.original.type)
        )

      },
      {
        accessorKey: "attributes",
        header: "Attributes",
        cell: ({ row, getValue }) => (
          <>
            <ListAttributes attributes={findExtendedAttributes(row?.original)} rowId={row.original.id} />
          </>
        )

      },
      {
        accessorKey: "action",
        header: "",
        cell: ({ row, getValue }) => (
          <div className="menu_button_container">
            <AddIcon id={`field-action-${row.original.name}`} className={"menu_button"} aria-controls="simple-menu" aria-haspopup="true"   onClick={(event) => handleMenuOpen(event, row.original?.id)} />

            <Menu
              id={`field-menu-${row.original.id}`}
              // anchorEl={anchorEl}
              className={`option_menu_${row.original.name}`}
              open={Boolean(anchorEl) && selectedRowId === row.original.id}
              onClose={handleMenuClose}
              anchorReference="anchorPosition" // Enable manual positioning
              anchorPosition={menuPosition} // Set custom X, Y position
            >
              {filterMenuOptions(attributes_options, row?.original?.type).map(item => (
                <MenuItem id={`${row.original.name}-option-${item.id}`} className={`attribute_menu_option menu_option_${item.id}`} onClick={(event) => handleOptionClick(item.id, event, row.original?.id)}  >
                  <FiberManualRecordIcon className={"menu_option_circle"} style={{color: getOptionItemColor(row?.original, item.id)}} />
                  <span>{item.title}</span>
                </MenuItem>
              ))}
            </Menu>

            {/* { dropdownAnchorEl && <DropdownOptions field_id={row.original?.id} updateSchemaWithAttribute={updateSchemaWithAttribute}  anchorEl={dropdownAnchorEl} setAnchorEl={setDropdownAnchorEl} position={dropdownPosition} /> } */}

          </div>
        ),
      },
    ]
  }, [anchorEl, selectedRowId, tableData])


  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
    state: {
      expanded,
    },
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    onExpandedChange: setExpanded,
    getSubRows: row => row.subRows,
    debugTable: true,
  });

  return (
    <>
      <table id={"field_extension_table"}  style={{ width: '100%'}}>
        <thead style={{ background: '#3f4e5c', color: '#fff' }}>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id} >
              {headerGroup.headers.map((header) => (
                <th key={header.id} className={`p-2 table_heading_cells`}>
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} className={"table_row"}>
              {row.getVisibleCells().map((cell) => (
                <td key={cell.id} className="p-2">
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}

          {table?.getRowModel()?.rows?.length == 0 && (
            <tr className={"table_row no-data-row"} >
              <td colspan="4" className="no_fields_alert p-2">No message fields</td>
            </tr>
          )}
        </tbody>
      </table>

      { dropdownAnchorEl && selectedRowId && <DropdownOptions field_id={selectedRowId} updateSchemaWithAttribute={updateSchemaWithAttribute}  anchorEl={dropdownAnchorEl} setAnchorEl={setDropdownAnchorEl} position={dropdownPosition} dropdownSchema={dropdownSchema} /> }

    </>
  );
}
export default FieldExtensionTable;

